let transitNum = 1;

export function addForm() {
  const $addForm = $('.js-addForm');
  const $addPoint = $('.js-addPoint');

  $addForm.on('click', () => {

    var sta_via = $(document).find('input[name="sta_via[]"]');

    if( sta_via.length > 0 ){
      transitNum = sta_via.eq(sta_via.length-1).data("no")+1;
    }

    addEle($addPoint);

    if (transitNum > 6) {
      $addPoint.remove();
    }
  });

  //▼会社名
  $("input[name='kojin_name']").on("click",function(){

    var boolean = $(this).prop("checked")
    var objCompanyName = $("input[name='company_name']");

    if( boolean ){
      objCompanyName.css("background-color","rgb(255, 255, 255)");
      objCompanyName.removeClass("required validate[required]");
      objCompanyName.prev(".formError").remove();
      
      
    }else{
      objCompanyName.css("background-color","rgb(255, 204, 204)");
      objCompanyName.addClass("required validate[required]");
    }

  });
  
  //▼ご検討される利用形態
  $(".group_ride_car").hide();
  $(".group_use_car").hide();

  $("input[name='use_style']").on("click",function(){

    var boolean = $(this).prop("checked");
/*
    $("input[name='use_style']").prop("checked",false);

    if( boolean ){
      $(this).prop("checked",true);

    }else{
      $(this).prop("checked",false)
    }
*/

    //▼ご希望車種制御
    if( boolean ){
        switch( $(this).data("id") ){
          case 0:
            $(".group_ride_car").show();
            $(".group_use_car").hide();
            break;
          case 1:
            $(".group_ride_car").hide();
            $(".group_use_car").show();
            break;
          case 2:
            $(".group_ride_car").show();
            $(".group_use_car").show();
            break;
          default:
            $(".group_ride_car").hide();
            $(".group_use_car").hide();
            break;
        }
      
    }else{
      $(".group_ride_car").hide();
      $(".group_use_car").hide();
    }

  });
  
  //▼フリガナ自動入力機能
  $.fn.autoKana('#name_sei', '#name_sei_kana', {
    katakana : true  //true：カタカナ、false：ひらがな（デフォルト）
  });

  $.fn.autoKana('#name_mei', '#name_mei_kana', {
    katakana : true  //true：カタカナ、false：ひらがな（デフォルト）
  });

  $.fn.autoKana('#representative_sei', '#representative_sei_kana', {
    katakana : true  //true：カタカナ、false：ひらがな（デフォルト）
  });

  $.fn.autoKana('#representative_mei', '#representative_mei_kana', {
    katakana : true  //true：カタカナ、false：ひらがな（デフォルト）
  });

  //▼必須項目色変え
  $('.required').css({backgroundColor:'#ffcccc'});

  $(document).on('keydown keyup keypress change focus blur','.required',function(){
    
    if($(this).val() == ''){
      $(this).css({backgroundColor:'#ffcccc'});
    } else {
        $(this).css({backgroundColor:'#fff'});
    }

  });

  //▼バリデーション
  $("#spotreserve_form").validationEngine({
    // 以下のパラメータは任意
    promptPosition: "topLeft",//エラー文の表示位置
    showArrowOnRadioAndCheckbox: true,//エラー箇所の図示
    focusFirstField: false,//エラー時に一番文頭の入力フィールドにフォーカスさせるかどうか
    scroll: false
  });

  $("#spotinquiry_form").validationEngine({
    // 以下のパラメータは任意
    promptPosition: "topLeft",//エラー文の表示位置
    showArrowOnRadioAndCheckbox: true,//エラー箇所の図示
    focusFirstField: false,//エラー時に一番文頭の入力フィールドにフォーカスさせるかどうか
    scroll: false
  });

  $("#estimate_form").validationEngine({
    // 以下のパラメータは任意
    promptPosition: "topLeft",//エラー文の表示位置
    showArrowOnRadioAndCheckbox: true,//エラー箇所の図示
    focusFirstField: false,//エラー時に一番文頭の入力フィールドにフォーカスさせるかどうか
    scroll: false
  });

}

function addEle(ele) {
  $(
    '<div class="contactCont_inner"><div class="contactCont_box"><input type="text" class="contact_input" name="sta_via[]" data-no="'+transitNum+'" placeholder="経由地' +
      transitNum +
      'の入力"/></div></div>'
  ).insertBefore(ele);

  transitNum++;
}
